module.exports = __webpack_public_path__ + "img/bul_feature01_active.6eace511.svg";